var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 141,
    viewBox: "0 0 213 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_1886)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_945_1886",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 213,
    height: 141
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.031 0.981445L0.0305176 0.981445L0.0305176 140.698L212.031 140.698L212.031 0.981445Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_945_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.327 17.8912C154.16 8.4652 130.567 3.2666 106.002 3.2666C81.4372 3.2666 57.9007 8.4652 39.7342 17.8912C15.9691 30.2308 2.31567 49.5398 2.31567 70.8484C2.31567 92.1569 15.9691 111.409 39.7342 123.748C57.9007 133.232 81.4372 138.43 106.002 138.43C130.567 138.43 154.16 133.232 172.327 123.748C196.092 111.409 209.745 92.1569 209.745 70.8484C209.745 49.5398 196.092 30.2308 172.327 17.8912Z",
    fill: "#B5FF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.327 17.8912C154.16 8.4652 130.567 3.2666 106.002 3.2666C81.4372 3.2666 57.9007 8.4652 39.7342 17.8912C15.9691 30.2308 2.31567 49.5398 2.31567 70.8484C2.31567 92.1569 15.9691 111.409 39.7342 123.748C57.9007 133.232 81.4372 138.43 106.002 138.43C130.567 138.43 154.16 133.232 172.327 123.748C196.092 111.409 209.745 92.1569 209.745 70.8484C209.745 49.5398 196.092 30.2308 172.327 17.8912Z",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.002 106.439C143.863 106.439 174.555 90.5043 174.555 70.8482C174.555 51.1922 143.863 35.2578 106.002 35.2578C68.1412 35.2578 37.449 51.1922 37.449 70.8482C37.449 90.5043 68.1412 106.439 106.002 106.439Z",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.002 106.439C134.05 106.439 156.788 90.5043 156.788 70.8482C156.788 51.1922 134.05 35.2578 106.002 35.2578C77.9534 35.2578 55.2156 51.1922 55.2156 70.8482C55.2156 90.5043 77.9534 106.439 106.002 106.439Z",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.508 70.8482C138.508 90.5001 123.94 106.439 106.002 106.439C88.0641 106.439 73.5537 90.5001 73.5537 70.8482C73.5537 51.1964 88.0641 35.2578 106.002 35.2578C123.94 35.2578 138.508 51.1964 138.508 70.8482Z",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.002 35.2578L106.002 106.439",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.555 70.8481L37.5061 70.8481",
    stroke: "#1F1F1F",
    strokeWidth: 4.5702,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_1886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 139.734,
    fill: "white",
    transform: "translate(0.0305176 0.981445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeGreen);
export default __webpack_public_path__ + "static/media/GlobeGreen.c71fe6b6d59fd6a6ac1156d9089ea218.svg";
export { ForwardRef as ReactComponent };